import { render, staticRenderFns } from "./RemoteComponent.vue?vue&type=template&id=c4e432ae&"
import script from "./RemoteComponent.vue?vue&type=script&lang=js&"
export * from "./RemoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RemoteComponent.vue?vue&type=style&index=0&id=c4e432ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports